export const textNormalize = (value?: string): string | undefined => value && value.trimStart();
